import moment from "moment";
import "moment/locale/id";

export const convertCustomerList = (data) => {
  let convertedCustomerList = [];

  if (!data) return [];

  data.forEach((item, index) => {
    convertedCustomerList.push({
      key: index + 1,
      ktp: item.ktp_picture,
      idCustomer: item.id,
      customerName: item.ktp_name,
      phone: `${item.phone_1}`,
      status: item.loan_status === "active" ? "Aktif" : "Non-Aktif",
      nik: item.ktp_number,
      gender: item.gender,
      birthdate: item.birth_date,
      province: item.province,
      subdistrict: item.subdistrict,
      city: item.city,
      village: item.village,
      address: item.address,
      lastTransaction: item.last_transaction
        ? moment(item.last_transaction).format("DD MMMM YYYY")
        : "-",
    });
  });
  return convertedCustomerList;
};
